import Model from '@tripian/model';

interface IFocusState {
  step?: Model.Step;
  alternative?: { poi: Model.Poi; stepId: number };
  poi?: Model.Poi;
}

export default IFocusState;

export const initialFocusState: IFocusState = {};
